import React, { useState, useEffect, useRef } from "react";
import { createPortal } from "react-dom";

const DropdownCell = ({ value, options, onChange }) => {
  const [open, setOpen] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0, width: 0 });
  const wrapperRef = useRef(null);
  const portalRef = useRef(null);

  const selectedOption = options.find(opt => String(opt.value) === String(value));

  const handleToggle = () => {
    if (!open && wrapperRef.current) {
      const rect = wrapperRef.current.getBoundingClientRect();
      setPosition({
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
        width: rect.width,
      });
    }
    setOpen(!open);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target) &&
        portalRef.current &&
        !portalRef.current.contains(event.target)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div ref={wrapperRef} style={{ position: "relative", width: "100%" }}>
      {/* Selected value (truncated) */}
      <div
        onClick={handleToggle}
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          border: "1px solid #ccc",
          borderRadius: 6,
          padding: 4,
          cursor: "pointer",
        }}
        title={selectedOption ? selectedOption.label : "Select..."}
      >
        {selectedOption ? selectedOption.label : "Select..."}
      </div>

      {open &&
        createPortal(
          <div
            ref={portalRef}
            style={{
              position: "absolute",
              top: position.top,
              left: position.left,
              width: Math.max(position.width, 280),
              maxHeight: 200,
              overflowY: "auto",
              border: "1px solid #ccc",
              backgroundColor: "#fff",
              borderRadius: 6,
              boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
              zIndex: 1000,
            }}
          >
            {options.map((opt) => (
              <div
                key={opt.id}
                onClick={() => {
                  onChange(opt.value);
                  setOpen(false);
                }}
                style={{
                  padding: "4px 8px",
                  cursor: "pointer",
                  backgroundColor: String(opt.value) === String(value) ? "#dbeafe" : "#fff",
                }}
              >
                {opt.label}
              </div>
            ))}
          </div>,
          document.body
        )}
    </div>
  );
};

export default DropdownCell;
